import { type HexColor } from '@myre/common-primitives';

import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'myre-colorpicker-list',
  templateUrl: './color-picker-list.component.html',
  styleUrls: ['./color-picker-list.component.scss'],
  imports: [NgClass],
})
export class ColorPickerListComponent {
  @Input()
  public colorSet: Record<string, HexColor>;

  @Input()
  public activeColors: string[] = [];

  @Input()
  public value: string;

  @Output('select')
  public select: EventEmitter<string> = new EventEmitter<string>();

  public variants: string[] = [
    '900',
    '800',
    '700',
    '600',
    '500',
    '400',
    '300',
    '200',
    '100',
  ];
}
